import React from 'react'
import { connect, ReactReduxContext } from 'react-redux'

import { FiltersButton } from '..'
import { enableQueryOnFiltersChange, disableQueryOnFiltersChange } from '../../actions'
import { areFiltersDefault } from '../../helpers'
import { showFiltersModal } from '../../modals'

const FiltersButtonContainer = props => (
    <ReactReduxContext.Consumer>
        {({ store }) => (
            <>
                <FiltersButton {...props} className="hidden-xs" />
                <FiltersButton {...props} className="hidden visible-xs-inline-block"
                    onClick={() => props.onClickXS(store)} />
            </>
        )}
    </ReactReduxContext.Consumer>
)

/** @param {import("../../store").SearchState} state */
const mapStateToProps = ({ filters }) => ({
    hasCustomFilter: !areFiltersDefault(filters),
})

const mapDispatchToProps = (dispatch, { onClick }) => ({
    onClickXS: (store) => {
        showFiltersModal(store, () => dispatch(enableQueryOnFiltersChange()))
        dispatch(disableQueryOnFiltersChange())
        onClick(false)
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(FiltersButtonContainer)
